import ScrollCarousel from '../ScrollCarousel';

/**
 * Announcement bar carousel — a full-width, single-slide, always-looping
 * carousel with optional autoplay. Thin configuration over ScrollCarousel;
 * keeps its own class names because the Liquid and SCSS are written against
 * `.Announcements__*`.
 */
class AnnouncementCarousel extends ScrollCarousel {
  constructor(element, options = {}) {
    super(element, {
      ...options,
      classes: {
        viewport: 'Announcements__viewport',
        track: 'Announcements__track',
        arrow: 'Announcements__arrow',
        arrowPrev: 'Announcements__arrow--previous',
        arrowNext: 'Announcements__arrow--next',
        arrowDisabled: 'Announcements__arrow--disabled',
        pause: 'Announcements__pause',
      },
      loop: true,
      slidesPerView: 1,
      pageDots: false,
      adaptiveHeight: false,
      ariaLabel: 'Announcements',
      arrowLabels: { previous: 'Previous announcement', next: 'Next announcement' },
      pauseLabels: { pause: 'Pause announcements', play: 'Play announcements' },
    });
  }
}

export default AnnouncementCarousel;
